/**
 * Blip Go — UUIDs de produto e variação (PRD + HML).
 * Quando o documento já possui produto contratado, o card e itens do carrinho devem sumir.
 */
export const BLIP_GO_SKU = 'blip-go';

export const BLIP_GO_PRODUCT_UUIDS = [
  '0896c705-700b-44f6-af27-bfd27ac6e1db', // PRD
  '2fed4f84-edfe-481f-8cac-e83382406aa5', // HML
];

export const BLIP_GO_VARIATION_UUIDS = [
  // PRD
  '685f1df2-a301-4313-8d61-ebd92956987a', // Blip Go - Básico
  '8d5a7a14-cd49-4bc3-8173-b9669375f414', // Blip Go - Intermediário
  'dfd65bfd-731f-4cc3-bca1-e9c2d3c24112', // Blip Go - Avançado
  // HML
  'ff16843a-ec91-4237-b22c-f21365729320', // Blip basic
  'a3ddd08c-82e4-4e89-b750-d90e11db2fd5', // Blip pro
  'e62c9728-ab50-447c-8c44-4b47536a77a6', // Blip enterprise
];

export function isBlipGoProductUuid(uuid?: string | null): boolean {
  return !!uuid && BLIP_GO_PRODUCT_UUIDS.includes(uuid);
}

export function isBlipGoVariationUuid(uuid?: string | null): boolean {
  return !!uuid && BLIP_GO_VARIATION_UUIDS.includes(uuid);
}

export function isBlipGoSku(sku?: string | null): boolean {
  return (sku ?? '').trim().toLowerCase() === BLIP_GO_SKU;
}

export function isBlipGoProduct(product?: {
  uuid?: string;
  sku?: string;
} | null): boolean {
  if (!product) {
    return false;
  }

  return isBlipGoProductUuid(product.uuid) || isBlipGoSku(product.sku);
}

/** Item do carrinho é Blip Go (produto ou variação). */
export function isBlipGoCartItem(item?: {
  product?: { uuid?: string; sku?: string } | null;
  selectedVariation?: { uuid?: string } | null;
} | null): boolean {
  if (!item) {
    return false;
  }

  return (
    isBlipGoProduct(item.product) ||
    isBlipGoVariationUuid(item.selectedVariation?.uuid) ||
    isBlipGoProductUuid(item.selectedVariation?.uuid)
  );
}
